"use client";

import { c as _c } from "react/compiler-runtime";
import { RiMailLine, RiMessage2Line } from "react-icons/ri";
import { cx } from "@/lib/tailwind-utils";
import { formatDelay } from "./format";
import type { SequenceDraft } from "./types";
const EFFECT_LABELS = {
  SEND_SMS: "SMS",
  SEND_EMAIL: "Email"
} as const;
interface RowProps {
  draft: SequenceDraft;
  onClick?: () => void;
  selected?: boolean;
}

/**
 * One sequence row. Read-only when no `onClick` is provided.
 */
export function Row(t0) {
  const $ = _c(27);
  const {
    draft,
    onClick,
    selected
  } = t0;
  const Icon = draft.effectType === "SEND_EMAIL" ? RiMailLine : RiMessage2Line;
  let t1;
  if ($[0] !== draft) {
    t1 = previewBody(draft);
    $[0] = draft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const body = t1;
  const t2 = !onClick;
  const t3 = onClick && "cursor-pointer hover:border-primary/40";
  const t4 = !onClick && "cursor-default";
  const t5 = selected ? "border-primary ring-1 ring-primary/30" : "border-border";
  const t6 = !draft.isActive && "opacity-60";
  let t7;
  if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = cx("w-full text-left rounded-md border bg-background transition-colors", "px-3 py-2", t3, t4, t5, t6);
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== Icon) {
    t8 = <Icon size={12} className="shrink-0 text-foreground-secondary" />;
    $[7] = Icon;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== draft.delayMinutes) {
    t9 = formatDelay(draft.delayMinutes);
    $[9] = draft.delayMinutes;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <span className="text-caption-strong text-foreground">{t9}</span>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const t11 = EFFECT_LABELS[draft.effectType];
  let t12;
  if ($[13] !== t11) {
    t12 = <span className="text-tiny text-foreground-muted">· {t11}</span>;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t12 || $[17] !== t8) {
    t13 = <div className="flex items-center gap-2">{t8}{t10}{t12}</div>;
    $[15] = t10;
    $[16] = t12;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== body) {
    t14 = body && <p className="mt-1 line-clamp-2 text-caption text-foreground-secondary">{body}</p>;
    $[19] = body;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== onClick || $[22] !== t13 || $[23] !== t14 || $[24] !== t2 || $[25] !== t7) {
    t15 = <button type="button" disabled={t2} onClick={onClick} className={t7}>{t13}{t14}</button>;
    $[21] = onClick;
    $[22] = t13;
    $[23] = t14;
    $[24] = t2;
    $[25] = t7;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
}
function previewBody(draft: SequenceDraft): string | undefined {
  if (draft.effectType === "SEND_SMS") return draft.smsBody?.trim() || undefined;
  const subject = draft.emailSubject?.trim();
  const body = draft.emailBody?.trim();
  if (subject && body) return `${subject} — ${body}`;
  return subject || body || undefined;
}